import { render, staticRenderFns } from "./MessageBox.vue?vue&type=template&id=16e0ff82"
import script from "./MessageBox.vue?vue&type=script&lang=js"
export * from "./MessageBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports